/* eslint-disable */
import { useEffect, useState } from 'react';
import { userService } from '../services/userService';
import {
	UpdateProfileRequest,
	UpdateUserRoleRequest,
	CoachPerformanceStats,
	LearnerAchievements,
	ProgramRateItem,
	AdminDashboardAnalytics,
} from '../types/user';

export function useAdminDashboardAnalytics() {
	const [analytics, setAnalytics] = useState<AdminDashboardAnalytics | null>(
		null
	);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchAnalytics = async () => {
		setLoading(true);
		setError(null);

		try {
			const data = await userService.getAdminDashboardAnalytics();
			setAnalytics(data);
		} catch (err: any) {
			console.error('Error fetching analytics:', err);
			setError(err.message || 'Failed to fetch analytics');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchAnalytics();
	}, []);

	return {
		analytics,
		loading,
		error,
		fetchAnalytics,
	};
}
